import Svg, { Path } from 'react-native-svg'

const SaleIncrease = () => {
  return (
    <Svg width={64} height={64} viewBox="0 0 64 64">
      <Path d="M32 0A32 32 0 110 32 32 32 0 0132 0z" fill="#0070b6" />
      <Path d="M16 16h32v32H16z" fill="none" />
      <Path
        d="M37.334 24l3.053 3.053-6.507 6.507-5.333-5.333-9.88 9.893 1.88 1.88 8-8 5.333 5.333 8.4-8.387L45.334 32v-8z"
        fill="#fff"
      />
    </Svg>
  )
}

export { SaleIncrease }
